export { AtnDsMeasuredElement as Directive } from './measured-element.directive'
